import React from 'react';
import merge from 'classnames';

import { ProgressSpinner } from '@/components/generic/ProgressSpinner';

import { Props } from './types';

import styles from './MainLoaderV2.module.scss';

export const MainLoader = ({ fullscreen = false }: Props) => (
  <div
    className={merge(styles.content, { [styles.fullscreen]: fullscreen })}
    data-testid="main-loader"
  >
    <ProgressSpinner />
  </div>
);
